import { render, staticRenderFns } from "./default-view.vue?vue&type=template&id=27a163e0"
import script from "./default-view.vue?vue&type=script&lang=js"
export * from "./default-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports